import Vue from 'vue';

export default {
    namespaced: true,

    state: () => ({
        page: '',
        fragments: {}
    }),

    getters: {
        page: state => state.page,
        fragments: state => slotName => state.fragments[slotName]
    },

    actions: {
        loadStaticPage({ rootState, commit }, { pageName = rootState.route.path.slice(1) } = {}) {
            return Promise.all([
                this.$api.getStaticPage(pageName),
            ]).then((page) => {
                commit('setStaticPage', page);
            })
        },

        loadStaticFragments({commit}, {slotName, cityId}) {
            return Promise.all([
                this.$api.getStaticFragment(slotName, cityId)
            ]).then((fragment) => {
                commit('setFragments', {
                    slotName,
                    fragment: fragment[0].length ? fragment[0][0].content : ''
                });
            })
        }
    },

    mutations: {
        setStaticPage(state, page) {
            state.page = page[0].content;
        },

        setFragments(state, {slotName, fragment}) {
            Vue.set(state.fragments, slotName, fragment); // как-то можно избежать импорта для Vue.set?
        }
    },
};
